<template>
    <div class="appraisalTooBar">
        <div class="left_box" @click="back()">
            <van-icon class="appraisal_img" name="arrow-left" color="#fff"/>
        </div>
        <p class="appraisal_title">{{title}}</p>
    </div>
</template>

<script>
    export default {
        name: "MyHeader",
        props: {
            isGoback: {
                default: "yes", // 团委
                required: false,
            },
            title: {
                default: '智慧团建'
            }
        },
        methods: {
            back() { //左上角回退方法
                this.$emit('goback', "保留参数")
                if (this.isGoback == "yes") {
                    this.$router.back(-1)
                }
            },
        }

    }
</script>

<style scoped>
    .appraisalTooBar {
        position: fixed;
        display: flex;
        top: 0px;
        align-items: center;
        z-index: 100;
        height: 50px;
        width: 100%;
        font-size: 15px;
        background-color: #e32322;
    }

    .appraisal_img {
        padding: 0 10px;
        width: 30px;
        height: 30px;
        line-height: 30px;
        /*vertical-align: center;*/
    }

    .appraisal_title {
        margin: 0 auto;
        font-size: 15px;
        text-align: center;
        padding-right: 50px;
        color: white;
    }


</style>
